import { Component, OnInit, ViewEncapsulation } from '@angular/core';
declare var $: any, Swal;

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class CookiePolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

    // $(window).on('load resize scroll', function () {
    //   var f = $('footer');
    //   f.css({ position: 'static' });
    //   if (f.offset().top + f.height() < $(window).height()) {
    //     f.css({ position: 'fixed', bottom: '0', width: '100%' });
    //   }
    // });


    // $(document).ready(function () {
    //   const body = document.querySelector('body');
    //   body.style.setProperty('--screen-height', $(window).height() + "px");
    // });

  }

}
